var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.infinite)?_c('font-awesome-icon',{style:({ color: '#898989' }),attrs:{"icon":"infinity"}}):_vm._e(),_vm._v(_vm._s(_vm.formatted))],1)}
var staticRenderFns = []

export { render, staticRenderFns }